var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: _vm.$style.card },
    [
      _c("div", { staticClass: "text-center" }, [
        _c("img", {
          staticClass: "img-fluid",
          class: _vm.$style.image || _vm.styleClass.image,
          attrs: { src: _vm.item.image }
        })
      ]),
      _vm._v(" "),
      _c("JoinTitleParagraph", {
        attrs: {
          item: _vm.item,
          "style-class": {
            title: _vm.styleClass.title,
            paragraph: _vm.styleClass.paragraph
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }